import React from 'react'

const Popupchat: React.FC = () => {
    return (
        <div></div>
    )
}

export default Popupchat